//   优品排行
export default [{
  path: '/premiumRanking',
  name: 'premiumRanking',
  meta: {
    index: 2
  },
  component: () => import('@/views/premiumRanking/index')
}]
